<section [ngClass]="'admin-alert admin-alert--' + level">
  <span
    markdown
    class="admin-alert__message"
    [data]="message"
  ></span>
  @if (isClosable) {
    <button
      class="admin-alert__close-button"
      aria-label="Close"
      (click)="onClose()"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</section>
